import React from "react";
import { Upload, Modal, message, Button, Progress } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { NODE_API, FILEACTIONURL } from "../../../config";
import { uploadFile, shrink } from '../../../utils/api'
import request from '../../../utils/request'

import { guid } from "../../../config/func";
import store from "../../../redux/store";
// import ImageCompressor from 'image-compressor.js';

class Uploads extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            fileListArr: [],
            fileList: [],
            showGetSearch: true,
            isShowProgress: false,
            percent: 0,
        };
    }
    componentWillMount() {
        console.log(this.props)
        if (this.props.serrArr) {
            let imgArr = []
            let imgArrTmp = []
            const serrArr = this.props.serrArr.split(',')
            const serrArrTmp = this.props.serrArrTmp ? this.props.serrArrTmp.split(',') : this.props.serrArr.split(',')
            console.log(serrArr)
            for (let i in serrArr) {
                imgArr.push({
                    uid: i,
                    status: 'done',
                    url: serrArr[i]
                })
                imgArrTmp.push({
                    uid: i,
                    status: 'done',
                    url: serrArrTmp[i]
                })
            }
            console.log(imgArr.length);
            this.setState({
                fileList: imgArr, //原图
                fileListArr: imgArrTmp, // 缩略图
                arrLength:imgArr.length,
            })
        }
    }

    getSearch = () => {
        const {fileList, fileListArr, previewImage} = this.state
        for (let i in fileList) {
            console.log(previewImage, fileListArr[i], previewImage == fileListArr[i].src);
            if (fileListArr[i].src) {
                if (previewImage === fileListArr[i].src) {
                    this.setState({
                        previewImage: fileList[i].src,
                        previewTitle: fileList[i].src.substring(fileList[i].src.lastIndexOf('/') + 1),
                        showGetSearch: false
                    });
                }
            } else {
                if (previewImage === fileListArr[i].url) {
                    this.setState({
                        previewImage: fileList[i].url,
                        previewTitle: fileList[i].url.substring(fileList[i].url.lastIndexOf('/') + 1),
                        showGetSearch: false
                    });
                }
            }
            
        }
    }
    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
        console.log(file)
        // if (!file.url && !file.preview) {
        //     file.preview = await this.getBase64(file.originFileObj);
        // }
        this.setState({
            previewImage: file.src || file.url,
            previewVisible: true,
            showGetSearch: true,
            previewTitle: file.name ? file.name :  file.src ? file.src.substring(file.src.lastIndexOf('/') + 1) : file.url.substring(file.url.lastIndexOf('/') + 1),
        });
    };

    getFile = async(url, fileName) => {
    // 通过 url 获取到 File
        function getFileFromUrl(url, fileName) {
            return new Promise((resolve, reject) => {
                let blob = null
                let xhr = new XMLHttpRequest()
                xhr.open('GET', url)
                // 这里设置接收的响应体类型(试了不设置也正常)
                xhr.responseType = 'blob'
                // 加载时处理(异步)
                xhr.onload = () => {
                // 获取返回结果
                blob = xhr.response
                console.log('blob:', blob)
                let file = new File([blob], fileName, { type: blob.type })
                // 返回结果
                resolve(file)
                }
                xhr.onerror = (e) => {
                reject(e)
                }
                // 发送
                xhr.send()
            })
        }
        const file = await getFileFromUrl(url, fileName)
        console.log('file:', file)
        return file
    }


    // base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
    dataURLtoFile = async(dataurl, filename, file) => {
        const arr = dataurl.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        if (n > parseInt(file['size'])) {
            //不稳定 暂时不考虑
            // let url1 = 'https://api.tinify.com/output/kt2kcgkv60cq4zekkabv1nc02t58y31a'
            // const fileName = '文件名称'
            // const newFile = await this.getFile(url1, fileName)

            const newFile = file
            console.log(newFile, '没有压缩')
            return newFile
        } else {
            const u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], filename, { type: mime })
        }
    }
    // 图片压缩函数
    compressImg (file) {
        const _this = this
        let files;
        const fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2)
        const read = new FileReader()
        read.readAsDataURL(file)
        return new Promise(function (resolve, reject) {
            read.onload = function (e) {
                const img = new Image()
                // 生成canvas
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                img.src = e.target.result
                img.onload = function () {
                    // 默认按比例压缩
                    const w = this.width
                    const h = this.height
                    const div = document.createElement('div')
                    div.style.cssText = "background: red";
                    console.log(w, h)
                    let base64
                    // 创建属性节点
                    canvas.setAttribute('width', w)
                    canvas.setAttribute('height', h)
                    ctx.clearRect(0, 0, w, h)
                    ctx.drawImage(this, 0, 0, w, h)
                    if (fileSize < 1) {
                        // 如果图片小于一兆 那么压缩0.1
                        base64 = canvas.toDataURL(file['type'], 0.9)
                    } else if (fileSize > 1 && fileSize < 2) {
                        // 如果图片大于1M并且小于2M 那么压缩0.5
                        base64 = canvas.toDataURL(file['type'], 0.5)
                    } else {
                        // 如果图片超过2m 那么压缩0.7
                        base64 = canvas.toDataURL(file['type'], 0.3)
                    }
                    files = _this.dataURLtoFile(base64, file.name, file) // 如果后台接收类型为base64的话这一步可以省略
                    resolve(files)
                }
            }
        })
    }
    beforeUpload = (file) => {
        return new Promise(async resolve => {
            let extension = ''
            if (file.name) {
                extension = file.name.substring(file.name.lastIndexOf('.'), file.name.length)
            }
            if (extension.toLowerCase() != '.jpg' && extension.toLowerCase() != '.png' && extension.toLowerCase() != '.jpeg') {
                message.error('上传格式有误，请重新上传jpg或png或jpeg格式！')
                return Upload.LIST_IGNORE
            }
            if (extension != '.jpg' && extension != '.png' && extension != '.jpeg') {
                this.setState({
                    currentFileType: 'ofd'
                })
            }
            // 限制上传五兆以上图片
            if (file.size > 5 * 1024 * 1024) {
                message.error("请上传5M以下的图片!");
                return Upload.LIST_IGNORE;
            }
            resolve(file)

            this.setState({
                suffix: extension,
            })
        })
    }
    handleDownload = (file) => {
        let url = file ? file.response.data : null;
        window.open(url)
    };
    handleCustomRequest = async(options) => {
        console.log(options);
        let ImgArr = []
        let ImgTmpArr = []
        const [{ suffix, fileList, fileListArr, isShowProgress }, {list} ] = [this.state, this.props];
        // let paramsObj = { output: 'json', scene: 'bsgzf', suffix };
        let paramsObj = { suffix };
        console.log(list);
        if (list && list.type && list.type == '补材料') {
            paramsObj = Object.assign(paramsObj, {flag: 1})
        }
        this.setState({
            isShowProgress: true
        })
        
        let fd = new FormData();    //定义参数
        // fd.append('file', options.file)
        // fd.append('output', paramsObj.output)
        // fd.append('scene', paramsObj.scene)
        // fd.append('suffix', paramsObj.suffix)

        fd.append('xslFile', options.file)
        fd.append('suffix', paramsObj.suffix.replace('.',''))
        // if (list && list.type && list.type == '补材料') {
        //     fd.append('flag', paramsObj.flag)
        // }
        request({
            url: FILEACTIONURL,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data;' },
            data: fd,
            onUploadProgress: ({ total, loaded }) => {
                console.log('监听到文件上传',total, loaded , Math.round((loaded / total) * 80).toFixed(2));
                this.setState({
                    percent: Math.round((loaded / total) * 80).toFixed(2)
                })
                // options.onProgress({ percent: Math.round((loaded / total) * 100).toFixed(2) }, newFile);
            },
        }).then(async response => {
          this.setState({
            percent: 85,
          });
          // const fileObj = await uploadFile(options.file, paramsObj)
          const newFile = await this.compressImg(options.file);
          const fileTmpObj = await uploadFile(newFile, paramsObj);
          this.setState({
            percent: 100,
            isShowProgress: false,
          });
          console.log(response);
          console.log(fileTmpObj);
          console.log(
            "🚀 ~ file: commonUploads.js:251 ~ Uploads ~ handleCustomRequest=async ~ list.type == '补材料':",
            list.type
          );
          //判断如果是补材料上传的图片，则在缩略图和原图的url和src后面增加后缀?disabledKindImg=true，来判断是否可以删除
          if (list.type === "补材料") {
            if (response.url.indexOf("disabledKindImg=true") >= 0) {
            } else {
              const content = response.src.split("/");
              content[content.length - 1] =
                content[content.length - 1] + "?disabledKindImg=true";
              response.url = content.join("/");
              response.src = content.join("/");
              fileTmpObj.url = content.join("/");
              fileTmpObj.src = content.join("/");
              const thumbnail = response.url.split("/");
              thumbnail[thumbnail.length - 1] =
                thumbnail[thumbnail.length - 1] + "?disabledKindImg=true";
              response.url = thumbnail.join("/");
              response.src = thumbnail.join("/");
              fileTmpObj.url = thumbnail.join("/");
              fileTmpObj.src = thumbnail.join("/");
            }
            // v.transactionAdditionList[index] = element;
          }
          console.log(
            "🚀 ~ file: commonUploads.js:293 ~ Uploads ~ handleCustomRequest=async ~ response.url:",
            response.url
          );
          Object.assign(response, {
            uid: fileList.length + 1,
          });
          Object.assign(fileTmpObj, {
            uid: fileList.length + 1,
          });
          console.log(
            "++++++++++++++++++++++++++++++++",
            fileList,
            fileListArr
          );

          const [fileListTmp, fileListArrTmp] = [fileList, fileListArr];
          fileListTmp.push(response);
          fileListArrTmp.push(fileTmpObj);
          this.setState({
            fileList: fileListTmp,
            fileListArr: fileListArrTmp,
          });
          console.log("12121--------------2", fileList, fileListArr);

          console.log(
            "🚀 ~ file: commonUploads.js:319 ~ Uploads ~ handleCustomRequest=async ~ fileListTmp:",
            fileListTmp
          );
          for (let i in fileListTmp) {
            ImgArr.push(fileListTmp[i].src || fileListTmp[i].url);
            console.log(
              "🚀 ~ file: commonUploads.js:321 ~ Uploads ~ handleCustomRequest=async ~ ImgArr:",
              ImgArr
            );
            ImgTmpArr.push(fileListArrTmp[i].src || fileListArrTmp[i].url);
            console.log(
              "🚀 ~ file: commonUploads.js:323 ~ Uploads ~ handleCustomRequest=async ~ ImgTmpArr:",
              ImgTmpArr
            );
          }
          this.props.setCommonImages(ImgArr, this.props.list, ImgTmpArr);
        }).catch(error => {
            console.log(error)
            this.setState({
                isShowProgress: false
            })
            message.error('上传失败,请重新上传!')
        })
    }
    handleRemove = (info) => {
      console.log("🚀 ~ file: commonUploads.js:312 ~ Uploads ~ info:", info);
      //   const isDeleteInfo = this.state.fileList[this.state.fileList?.length - 1];
      console.log(
        "🚀 ~ file: commonUploads.js:335 ~ Uploads ~ this.state.fileList:",
        this.state.fileList
      );
      //判断如果没有disabledKindImg=true，则不能删除；此状态是在补材料上传的时候加上的
      //info.uid == beforeFileList[i].uid; 表示删除的是当前文件，只在当前文件判断url有没有包含disabledKindImg=true
      const beforeFileList = this.state.fileList;
      for (let i in beforeFileList) {
        if (
          info.uid == beforeFileList[i].uid &&
          beforeFileList[i].url?.indexOf("disabledKindImg=true") <= 0
        ) {
          return message.error("不能删除已审核过的图片");
        }
      }

      // if(this.state.arrLength&& info.uid < this.state.arrLength){
      //     return message.error('不能删除已审核过的图片')
      // }

      // if (info.url.indexOf("disabledKindImg=true") <= 0) {
      //     return message.error('不能删除已审核过的图片')
      // }
      const fileList = [...this.state.fileList];
      console.log(
        "🚀 ~ file: commonUploads.js:343 ~ Uploads ~ fileList:",
        fileList
      );
      const fileListArr = [...this.state.fileListArr];
      console.log(
        "🚀 ~ file: commonUploads.js:345 ~ Uploads ~ fileListArr:",
        fileListArr
      );
      let ImgArr = [];
      let ImgTmpArr = [];
      for (let i in fileListArr) {
        if (info.url === fileListArr[i].url) {
          fileList.splice(i, 1);
          fileListArr.splice(i, 1);
          this.setState({
            fileList: fileList,
            fileListArr: fileListArr,
          });
        }
      }
      setTimeout(() => {
        for (let i in fileList) {
          ImgArr.push(fileList[i].src || fileList[i].url);
          ImgTmpArr.push(fileListArr[i].src || fileListArr[i].url);
        }
        this.props.setCommonImages(ImgArr, this.props.list, ImgTmpArr);
      }, 500);
    }
    render() {
        const { previewVisible, previewImage, fileList, fileListArr, previewTitle, currentFileType, isShowProgress, percent } = this.state;
        const uploadButton = (
            <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
            </div>
        );
        return (
            <div>
                
                <Upload
                    listType="picture-card"
                    showUploadList={currentFileType === 'ofd' ? { showDownloadIcon: true, showRemoveIcon: true, showPreviewIcon: false }: { showDownloadIcon: false, showRemoveIcon: true, showPreviewIcon: true }}
                    customRequest={this.handleCustomRequest}
                    beforeUpload={this.beforeUpload}
                    onPreview={this.handlePreview}
                    onDownload={this.handleDownload}
                    onRemove={this.handleRemove}
                    fileList={fileListArr}
                    // disabled={fileListArr.length >= 8}
                >
                    {/* {fileListArr.length >= 8  ? null : uploadButton} */}
                    {
                        uploadButton
                    }
                    {isShowProgress ?
                        <Progress style={{position: "absolute", background: "#fff"}} type="circle" percent={percent} width={80}/>
                        :
                        null
                    }
                </Upload>
                <Modal
                    visible={previewVisible}
                    title={previewTitle}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    {
                    this.state.showGetSearch ? 
                        <Button type="text" style={{position: "absolute", zIndex: 1, color: "white", background: "rgba(0,0,0,.6)"}} onClick={this.getSearch}>
                            查看原图
                        </Button>
                        : null
                    }
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
            </div>
        )
    }
}



export default Uploads
